<template>
  <div class="filter-box">
    <div class="filter-box-header">
      <div class="filter-box-title">
        <div class="filter-box-icon" />
        <div class="filter-box-text">{{ meta.label }}</div>
      </div>
      <!-- <div
        v-if="dimension.role==='filters'"
        class="eye"
        :class="{active: dimension.quick_filter}"
        @click="toggleQuickFilter"
      /> -->
      <div v-if="dimension.role!=='filters'" class="remove" @click="$emit('remove',dimension.id)" />
    </div>
    <select-comp-wrapper
      v-model="internalValue"
      :options="options"
      :multiple="dimension.role!=='filters'"
      :can-bold="dimension.role==='rows'"
      :can-chart="dimension.role=='columns'"
      :unsortable="meta.type==='time'"
    />
  </div>
</template>

<script>
import SelectCompWrapper from './SelectCompWrapper.vue'
export default {
  components: {
    SelectCompWrapper,
  },
  // SE HACE "a mano" porque v-model no funciona dentro de un "for"
  // model: {
  //   prop: 'dimension',
  //   event: 'change',
  // },
  props: {
    dimension: Object,
    options: Array,
    label: String,
    meta: Object,
  },
  computed: {
    internalValue: {
      get() {
        return this.dimension.values
      },
      set(value) {
        // this.dimension.values = value
        let newDimension = { ...this.dimension, values: value }
        this.$emit('change', newDimension)
      },
    },
  },
  methods: {
    toggleQuickFilter() {
      this.dimension.quick_filter = !this.dimension.quick_filter
      this.$emit('change', this.dimension)
    },
    // remove() {
    //   this.dimension.role = 'filters'
    //   this.$emit('change', this.dimension)
    // },
  },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="stylus" scoped>
.filter-box
  padding: vw(10px)
  background-color: $bcn-grey

.filter-box-header
  display: flex
  justify-content: space-between
  align-content: center
  margin-bottom: vw(10px)

.filter-box-title
  display: flex
  align-items: center
  gap: vw(2px)

.filter-box-icon
  m-icon("drag", 20)

.filter-box-text
  // m-first-letter-case()
  m-font-size(14, 20)
  font-weight: 600

.eye
  m-icon("eye", 20)

  &.active
    m-icon("eye-bold", 20)

.remove
  m-icon("close", 20)
  cursor: pointer
</style>
